<template>
  <div
    class="profile-avatar"
    data-testid="profile-avatar"
    @click="$emit('click')"
  >
    <img
      v-if="avatar"
      class="profile-avatar__img"
      :src="avatar"
      alt="profile-avatar"
      @error="handleError"
    >
    <div
      v-else
      class="profile-avatar__default"
    >
      <DefaultAvatarMale v-if="isMaleOrDiverse" />
      <DefaultAvatarFemale v-else />
    </div>
  </div>
</template>

<script>
import DefaultAvatarFemale from '@/components/icons/DefaultAvatarFemale.vue'
import DefaultAvatarMale from '@/components/icons/DefaultAvatarMale.vue'

const GENDER_MALE = 'male'
const GENDER_DIVERSE = 'diverse'

export default {
  name: 'ProfileAvatar',
  components: {
    DefaultAvatarMale,
    DefaultAvatarFemale
  },
  props: {
    avatar: {
      type: String,
      default: ''
    },
    gender: {
      type: String,
      default: GENDER_MALE
    }
  },
  emits: ['click', 'image-load-error'],
  computed: {
    isMaleOrDiverse() {
      return this.gender === GENDER_MALE || this.gender === GENDER_DIVERSE
    }
  },
  methods: {
    handleError() {
      this.$emit('image-load-error')
    }
  }
}
</script>

<style scoped lang="scss">
.profile-avatar {
  position: relative;
  border-radius: var(--border-radius-rounded);
  width: 100%;
  height: 100%;
  overflow: hidden;

  .profile-avatar__img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .profile-avatar__default svg {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
